export const setPhotoMargin = (i) => {
    if (i === 0) {
        return "mb-1 mr-1";
    } else if (i === 1) {
        return "mb-1";
    } else if (i === 2) {
        return "mr-1";
    }

    return "";
};
